import React, { useEffect, useState } from "react";
import { useFormContext, useFieldArray, Controller } from "react-hook-form";
import PhoneInput from "react-phone-number-input/react-hook-form-input";

import "react-phone-number-input/style.css";
import { PlusCircleIcon, MinusCircleIcon } from "@heroicons/react/24/outline";
import { Button } from "../../../components/button";

const EmergencyContacts = ({ siteId, contactTypes }) => {
  const { control, register, getValues, setValue, trigger } = useFormContext();
  const { fields, append, remove } = useFieldArray({
    control,
    name: "emergency_contacts",
  });

  return (
    <div className="pt-2">
      <fieldset className="sm:col-span-3">
        <legend className="block text-sm font-medium mb-1 text-gray-600 dark:text-gray-300">
          Emergency contacts
        </legend>

        {fields.map((field, index) => (
          <div key={field.id} className="flex mt-2 items-center">
            <Controller
              name={`emergency_contacts[${index}].type_id`}
              control={control}
              render={({ field }) => (
                <select
                  {...field}
                  onChange={(e) => {
                    field.onChange(parseInt(e.target.value, 10));
                  }}
                  className="flex-1 rounded-md border-0 px-3 py-2.5 text-sm leading-none font-normal transition-colors duration-150 text-gray-500 dark:text-gray-200 bg-gray-50 dark:bg-gray-800 hover:bg-gray-100 dark:hover:bg-white/[0.06] focus:outline-none"
                >
                  <option value="">Select type</option>
                  {contactTypes.map((type) => (
                    <option key={type.id} value={type.id}>
                      {type.name}
                    </option>
                  ))}
                </select>
              )}
            />
            <Controller
              control={control}
              name={`emergency_contacts[${index}].number`}
              render={({ field }) => (
                <PhoneInput
                  {...field}
                  country="US"
                  className="flex-1 rounded-md border-0 ml-2 px-3 py-2.5 text-sm leading-none font-normal transition-colors duration-150 text-gray-500 dark:text-gray-200 bg-gray-50 dark:bg-gray-800 hover:bg-gray-100 dark:hover:bg-white/[0.06] focus:outline-none"
                />
              )}
            />
            <Button
              variant="secondary"
              icon={MinusCircleIcon}
              aria-label="Remove contact"
              onClick={() => remove(index)}
              className="ml-2"
            />
          </div>
        ))}
        <Button
          variant="secondary"
          icon={PlusCircleIcon}
          aria-label="Add contact"
          onClick={() => append({ type_id: "", number: "" })}
        />
      </fieldset>
    </div>
  );
};

export { EmergencyContacts };
